import Carousel from "primevue/carousel";
import Button from "primevue/button";
import Galleria from "primevue/galleria";

export const components = {
  Carousel,
  Button,
  Galleria,
};
